import React from 'react'
import { useTable, usePagination, useSortBy } from "react-table"
import { decodeJWT } from './jwtUtils';
import { DEFAULT_PAGE_SIZE } from '../utils/paginationDefaults';

function TableCertificado({ columns, data, pageSize: externalPageSize = DEFAULT_PAGE_SIZE, setPageSize: setExternalPageSize, length = true, search = true, titulo = '' }) {
    const token = JSON.parse(localStorage.getItem("user_token"));
    const nivelUsuario = decodeJWT(token)?.nivel;
    const isAluno = nivelUsuario === 'Aluno';

    const props = useTable(
        {
            columns,
            data: data,
            initialState: { pageSize: externalPageSize },
            manualPagination: false,
            pageCount: -1
        },
        useSortBy,
        usePagination,
    );

    const {
        getTableBodyProps,
        getTableProps,
        headerGroups,
        rows,
        prepareRow,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        nextPage,
        previousPage,
        setPageSize: setPageSizeInternal,
        state: { pageIndex, pageSize: internalPageSize }
    } = props;

    // Sincronizar pageSize externo com interno (apenas quando mudar externamente, sem criar loop)
    const prevExternalRef = React.useRef(externalPageSize);
    React.useEffect(() => {
        if (externalPageSize !== undefined && externalPageSize !== prevExternalRef.current) {
            setPageSizeInternal(externalPageSize);
            prevExternalRef.current = externalPageSize;
        }
    }, [externalPageSize, setPageSizeInternal]);

    const pageSize = externalPageSize !== undefined ? externalPageSize : internalPageSize;


    return (
        <>
            <div className="table-full-width mt-3 mb-3">
                <div className="table-responsive">
                    <table {...getTableProps()} className="table align-middle mt-1 table-striped table-hover">
                        <thead>
                            <tr>
                                <th colSpan={
                                    headerGroups[0]?.headers.filter(column => {
                                        const isIdColumn = column.id === 'id' || column.accessor === 'id';
                                        const shouldHideId = isIdColumn && !isAluno;
                                        return column.visible !== false && !shouldHideId;
                                    }).length || 7
                                } className='bg-primary text-white rounded-top'>{titulo}</th>
                            </tr>
                        </thead>
                        <thead>
                            {headerGroups.map(headerGroup => (
                                <tr {...headerGroup.getHeaderGroupProps()} className='border border-white'>
                                    {headerGroup.headers.map(column => {
                                        const isIdColumn = column.id === 'id' || column.accessor === 'id';
                                        const shouldHideId = isIdColumn && !isAluno;
                                        const shouldHide = column.visible === false || shouldHideId;
                                        
                                        const isSortable = !column.disableSortBy;
                                        const headerProps = isSortable 
                                            ? column.getHeaderProps(column.getSortByToggleProps())
                                            : column.getHeaderProps();
                                        
                                        let headerClass = 'text-uppercase text-black-50 fw-medium fs-8 bg-muted px-2';
                                        if (column.id === 'data' || column.id === 'status' || column.id === 'acoes') {
                                            headerClass += ' text-center';
                                        }
                                        
                                        return (
                                            <th 
                                                {...headerProps} 
                                                className={`${headerClass} ${shouldHide ? "d-none" : ""}`} 
                                                style={isSortable ? { cursor: 'pointer' } : {}}
                                            >
                                                {column.render('Header')}
                                                {isSortable && (
                                                    <span className="ms-2">
                                                        {column.isSorted ? (
                                                            column.isSortedDesc ? (
                                                                <i className="bi bi-sort-down"></i>
                                                            ) : (
                                                                <i className="bi bi-sort-up"></i>
                                                            )
                                                        ) : (
                                                            <i className="bi bi-arrow-down-up text-muted"></i>
                                                        )}
                                                    </span>
                                                )}
                                            </th>
                                        );
                                    })}
                                </tr>
                            ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                            {page.map((row, i) => {
                                prepareRow(row);
                                return (
                                    <tr {...row.getRowProps()}>
                                        {row.cells.map(cell => {
                                            const isIdColumn = cell.column.id === 'id' || cell.column.accessor === 'id';
                                            const shouldHideId = isIdColumn && !isAluno;
                                            
                                            return (
                                                <td className={`${cell.column.visible === false || shouldHideId ? "d-none" : ""}`} {...cell.getCellProps()}>
                                                    {cell.render("Cell")}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                );
                            })}
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colSpan="7" className='bg-primary text-white rounded-bottom'>
                                    <div className="table-footer d-flex justify-content-between align-items-center">
                                        <span>Exibindo {pageSize < rows.length ? pageSize : rows.length} de {rows.length} registros</span>
                                        <div>
                                            <span>Página {pageIndex + 1} de {pageOptions.length}</span>
                                            <button className="btn btn-primary btn-sm ms-2 text-white" onClick={() => previousPage()} disabled={!canPreviousPage}>
                                                <i className="bi bi-caret-left"></i>
                                            </button>
                                            <button className="btn btn-primary btn-sm ms-1 text-white" onClick={() => nextPage()} disabled={!canNextPage}>
                                                <i className="bi bi-caret-right"></i>
                                            </button>
                                        </div>
                                    </div>
                                </th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </>
    )

}
export default TableCertificado;